import {map, some} from 'lodash';

import Loading from 'components/Loading';
import InlinePage from 'components/Page/Inline';
import {baseAccIdColumn} from 'components/Table/Cell/AccId';
import BooleanCell from 'components/Table/Cell/Boolean';
import {BooleanCheckboxFilter, booleanFilter} from 'components/Table/Filter/Boolean';
import TextFilter from 'components/Table/Filter/Text';
import SimpleTable from 'components/Table/Simple';
import {flexColumnStyle} from 'components/Table/columnHelpers';
import KyError from 'components/errors/KyError';
import ReadableWidthTemplate from 'components/templates/ReadableWidth';
import {useGet} from 'helpers/KyHooks';


export default function CpicPrioritizationGuidelines({}) {
  const {response, error} = useGet('data/guideline', {searchParams: {accessionId: 'notnull'}});

  let body = <Loading />;
  if (error) {
    body = <KyError kyError={error} />;
  } else if (response) {
    const tableData = map(response.data, (row) => ({
      guideline: row,
      level: row.level,
      updateInProgress: some(row.terms, (t) => t.term === 'Update In Progress'),
    }));

    const columns = [
      {
        id: 'guideline',
        Header: 'Guideline',
        accessor: 'guideline',
        ...baseAccIdColumn,
      },
      {
        id: 'level',
        Header: 'Level',
        accessor: 'level',
        sortable: true,
        Filter: TextFilter,
        ...flexColumnStyle({width: 110}),
      },
      {
        id: 'update',
        Header: 'Update In Progress',
        accessor: 'updateInProgress',
        Cell: BooleanCell,
        Filter: BooleanCheckboxFilter,
        filter: booleanFilter,
        ...flexColumnStyle({width: 110}),
      },
    ];

    body = (
      <div>
        <SimpleTable
          data={tableData}
          columns={columns}
          disableExport={false}
          initialState={{sortBy: [{id: 'guideline', desc: false}]}}
        />
        <InlinePage id="cpicPlannedGuidelines" showTitle={false} />
      </div>
    );
  }

  return (
    <ReadableWidthTemplate title="CPIC Guideline Prioritization">
      {body}
    </ReadableWidthTemplate>
  );
}
